import { writable, readable } from 'svelte/store';
import { _api_host, _bam_host, _bpm_host, _bpm_domain } from './constants.js';
export const home_data = writable({});
export const help_data = writable({});
export const step_pointer = writable('step1');
export const section_pointer = writable('section1');
export const api_host = readable(_api_host);
export const bam_host = readable(_bam_host);
export const bpm_host = readable(_bpm_host);
export const bpm_domain = readable(_bpm_domain);
